import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { axiosbaseurl } from "../../../config"
import Configs from "../../../config"

const NotificationDropdown = () => {
  const [notifications, setNotifications] = useState([])

  useEffect(() => {
    fetchNotifications()
  }, [])

  const fetchNotifications = async () => {
    try {
      const res = await axiosbaseurl.get("/notifications")
      if (res.data?.success) {
        setNotifications(res.data.data || [])
      }
    } catch (err) {
      console.error(err)
    }
  }

  const unreadCount = notifications.filter(n => !n.isRead).length

  return (
    <Link
      to={`${Configs.appurl}notifications`}
      className="btn header-item noti-icon position-relative"
    >
      <i className={`bx bx-bell text-dark ${unreadCount > 0 ? "bx-tada" : ""}`} />
      {unreadCount > 0 && (
        <span
          style={{
            position: "absolute",
            top: 20,
            right: 8,
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: "#dc3545",
            display: "inline-block",
          }}
        />
      )}
    </Link>
  )
}

NotificationDropdown.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(NotificationDropdown)
